export async function kameleoonInit(id?: string): Promise<void> {
  window.gtag =
    window.gtag ||
    function () {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };

  window.kameleoonQueue = window.kameleoonQueue || [];
  window.kameleoonQueue.push({
    level: 'IMMEDIATE',
    command: excludeKameleoonEval,
  });

  try {
    await renderKameleoonScript(id);
  } catch (error) {
    console.error('Failed to load Kameleoon script:', error);
  }
}

export function shouldLoadKameleoon(countryCode: string): boolean {
  return countryCode.toLowerCase() === 'us';
}

export function getKameleoonUrl(id?: string): string | undefined {
  if (id) {
    return `/kameleoon.js?id=${id}`;
  }
  return `/kameleoon.js`;
}

function renderKameleoonScript(id?: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (document.getElementById('ab-script')) {
      return resolve();
    }
    const url = getKameleoonUrl(id);
    if (!url) {
      return reject();
    }
    const headElement = document.head;
    const scriptTag = document.createElement('script');
    scriptTag.async = true;
    const nonceElement = document.querySelector('[nonce]');
    scriptTag.id = 'ab-script';
    scriptTag.src = url;
    const nonce =
      (nonceElement as unknown as { nonce: string | undefined })?.nonce ??
      nonceElement?.getAttribute('nonce');
    if (nonce) {
      scriptTag.setAttribute('nonce', nonce);
    }
    headElement.insertBefore(scriptTag, headElement.firstChild);
    scriptTag.onload = () => {
      resolve();
    };
    scriptTag.onerror = () => {
      console.error('Could not load Kameleoon');
      return reject();
    };
  });
}

function excludeKameleoonEval() {
  if (!Kameleoon || !Kameleoon.Utils) {
    console.error('Kameleoon Utils is unavailable');
    return;
  }
  Kameleoon.Utils.runProtectedScript = function (code: string, fileName?: string) {
    const script = document.createElement('script');
    script.innerHTML = code;
    if (fileName) {
      script.innerHTML += '//# sourceURL=' + fileName;
    }
    document.head.appendChild(script);
  };
}
